<template>
  <DialogWrapper
    class="agency-dialog"
    closeOnCancel
    :show.sync="isShow"
    :close-on-click-modal="false"
    :titleI18nKey="`${i18nPrefix}.label.shareToAgency`"
    @save="handelSave"
  >
    <div v-if="isShow" class="invite-agency-container">
      <div class="body-container">
        <div class="agency-select-container">
          <el-select
            v-model="agencyEmail"
            filterable
            class="select"
            :placeholder="$t(`${i18nPrefix}.placeholder.agency`)"
            @change="handleSelectAgency"
          >
            <el-option
              v-for="(agency, index) in selectList"
              :key="index"
              :label="agency.email_address"
              :value="agency.email_address"
            ></el-option>
          </el-select>
          <el-input class="name" readonly v-model="agencyName" :placeholder="$t(`${i18nPrefix}.placeholder.agencyName`)"></el-input>
          <span class="add-icon icomoon-add-box" @click="handelAddBtn"></span>
        </div>
        <div class="selected-list">
          <div
            class="selected-list-item"
            v-for="(item, index) in selectedList"
            :key="index">
            <span class="item-email">
              {{ item.email }}
            </span>
            <span class="item-name">
              {{ item.name }}
            </span>
            <span class="remove-icon icomoon-remove-box" @click="handelRemoveBtn(item.email, index)"></span>
          </div>
        </div>
        <div class="option-select-container">
          <el-checkbox-group v-model="optionList">
            <el-checkbox label="to_creator">{{ $t(`${i18nPrefix}.btn.agencyDialog.sendEmailCreator`) }}</el-checkbox>
            <el-checkbox label="to_member">{{ $t(`${i18nPrefix}.btn.agencyDialog.sendEmailCoordinator`) }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <RectLoading class="loading" v-show="loading"/>
  </DialogWrapper>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import RectLoading from '@/components/loading/rectLoading'

export default {
  components: {
    DialogWrapper,
    RectLoading
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    jobId: {
      required: true
    },
    isAll: {
      default: false
    },
    jobIds: {
      type: Array
    },
    filter: {
      required: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.list',
      loading: false,
      optionList: [],
      agencyEmail: '',
      agencyName: '',
      agencyList: [],
      selectedList: []
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    selectList () {
      const list = []
      _.forEach(this.agencyList, (item) => {
        if (!_.find(this.selectedList, ['id', item.pk])) {
          list.push(item)
        }
      })
      return list
    }
  },
  created () {
    this.initAgencyList()
  },
  methods: {
    ...mapActions('agency', ['getAgencyList', 'shareJobToAgency']),
    async initAgencyList () {
      this.loading = true
      try {
        const resp = await this.getAgencyList({ job_id: this.jobId })
        if (resp) {
          this.agencyList = resp
          this.initSelectedList()
          this.initOption()
        }
      } finally {
        this.loading = false
      }
    },
    initSelectedList () {
      if (this.isAll || this.jobIds?.length > 1) {
        return
      }
      _.forEach(this.agencyList, (item) => {
        if (item.has_invite) {
          this.selectedList.push({
            email: item.email_address,
            name: item.name,
            id: item.pk
          })
        }
      })
    },
    initOption () {
      if (this.isAll || this.jobIds?.length > 1) {
        return
      }
      if (_.find(this.agencyList, ['send_email_type', 'to_creator'])) {
        this.optionList.push('to_creator')
      } else if (_.find(this.agencyList, ['send_email_type', 'to_member'])) {
        this.optionList.push('to_member')
      } else if (_.find(this.agencyList, ['send_email_type', 'all'])) {
        this.optionList.push('to_creator')
        this.optionList.push('to_member')
      }
    },
    handleSelectAgency (value) {
      const agency = _.find(this.agencyList, ['email_address', value])
      if (agency) {
        this.agencyName = agency.name
      }
    },
    handelAddBtn () {
      const agency = _.find(this.agencyList, ['email_address', this.agencyEmail])
      if (agency) {
        this.selectedList.push({
          email: this.agencyEmail,
          name: this.agencyName,
          id: agency.pk
        })
        this.agencyEmail = ''
        this.agencyName = ''
      }
    },
    handelRemoveBtn (email, index) {
      this.selectedList.splice(index, 1)
    },
    async handelSave () {
      this.loading = true
      try {
        const selectAgencyIdList = _.map(this.selectedList, 'id')
        if (this.agencyEmail) {
          const agency = _.find(this.agencyList, ['email_address', this.agencyEmail])
          if (agency) {
            selectAgencyIdList.push(agency.pk)
          }
        }
        const params = {
          job_id: this.jobId,
          headhunter_ids: selectAgencyIdList
        }
        if (this.isAll) {
          params.is_all = true
          params.filter = this.filter
        }
        if (this.jobIds) {
          params.job_ids = this.jobIds.join(',')
        }
        if (this.optionList.length >= 2) {
          params.send_type = 'all'
        } else if (this.optionList.length > 0) {
          params.send_type = this.optionList[0]
        }
        const resp = await this.shareJobToAgency(params)
        if (resp === 'success') {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.postToAgencySuccess`))
        } else if (resp === 'empty') {
          this.$message.warning(this.$t(`${this.i18nPrefix}.message.postToAgencyEmpty`))
        }
      } finally {
        this.isShow = false
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.agency-dialog {
  .invite-agency-container {
    white-space: nowrap;
    word-break: keep-all;

    .header-container {
      padding: 22px 36px;
      border-radius: 4px;
      background: #F5F7FA;

      .label {
        color: #0096cc;
        font-size: 18px;
        font-weight: bold;
      }
    }

    .body-container {
      padding: 0 0 20px 0;

      .agency-select-container {
        display: flex;
        justify-content: space-between;

        .select {
          width: 50%;
        }

        .name {
          width: 37%;
        }

        .add-icon  {
          width: 10%;
          text-align: right;
          font-size: 32px;
          cursor: pointer;

          &::before {
            color: #0096cc;
          }
        }

      }
      .selected-list {
        padding: 10px 0;

        .selected-list-item {
          display: flex;
          justify-content: space-between;
          overflow: hidden;
          padding: 8px 0;
          line-height: 16px;
          font-size: 14px;

          > span {
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .item-email {
            width: 50%;
          }
          .item-name {
            width: 37%;
          }

          .remove-icon {
            width: 10%;
            text-align: right;
            font-size: 32px;
            cursor: pointer;

            &::before {
              color: #0096cc;
            }
          }
        }
      }
      .option-select-container {
        ::v-deep .el-checkbox-group {
          > label {
            font-weight: unset;
            display: block;
          }
        }
      }
    }
  }

  .loading {
    position: absolute;
  }
}
</style>
